import { render } from "./matching-card-placeholder.vue?vue&type=template&id=dfc82f4e&scoped=true&ts=true"
import script from "./matching-card-placeholder.vue?vue&type=script&lang=ts"
export * from "./matching-card-placeholder.vue?vue&type=script&lang=ts"

import "./matching-card-placeholder.vue?vue&type=style&index=0&id=dfc82f4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc82f4e"]])

export default __exports__